import React from 'react'
import ClientOptionsContext from './ClientOptionsContext'
import type { ClientOptionsValue } from './ClientOptionsContext'

export default function useClientOptions(): ClientOptionsValue {
  const clientOptions: ClientOptionsValue = React.useContext(ClientOptionsContext)

  return clientOptions
}
